import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { APP_ROUTING_NAMES } from '../app.routes.names';
import { CookieService } from 'ngx-cookie';
import { AuthService } from '../service/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-logged-in',
    templateUrl: './logged-in.component.html',
    styleUrls: ['./logged-in.component.scss'],
    standalone: false
})

export class LoggedInComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    @Inject(AuthService) private authService: AuthService
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      let token = this.getTokenFromCookie();
      if(token){
        // set token
        this.authService.setToken(token);
        //redirect to start
        this.router.navigate(['login/ansokan/start']);
      }else{
        this.router.navigate([APP_ROUTING_NAMES.NOT_FOUND]);
      }
    
    });
  }

  /** Returns the token from the cookie. Returns undefined if no cookie exists. */
  public getTokenFromCookie(): any {
    const token = this.cookieService.get(environment.appCode + '-token');
    if (token) {
      return token;
    }
    return null;
  }

}
